module.exports = __webpack_public_path__ + "static/media/inventory.a521b63a.svg";